import React from "react";
import { useMediaQuery } from 'react-responsive';
import BecomeApiProviderTemplate from "./BecomApiProviderTemplate";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PublishingApis = () => {
    const smallScreens = useMediaQuery({ maxWidth: 639});

    return (
        <BecomeApiProviderTemplate>
            <section>
                <h1 className="a-one-paturegular fs-40">Publishing APIs</h1>
                <p>
                    The process of publishing your API on Digital Gateway can seem daunting, but don’t worry. Our process is designed to ensure your questions are answered and we are both prepared for your API’s go-live day and beyond. Here’s what you can expect during the publishing process. Remember, we’re here for you each step of the way.
                </p>
            </section>
            <section className="grid-col-12">
                <div className="grid-row grid-gap flex-justify-center">
                <div className="display-none tablet:display-block grid-col-4"></div>
                <div className={ smallScreens ? "grid-col-8 w-100" : "grid-col-8"}>
                    {/* <h2 className="page-title patua-one-regular">Steps to publish your APIs:</h2>
                    <hr/> */}
                    <Accordion className="mb-5" slotProps={{ heading: { component: 'h2' } }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">1. Contact us</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            Giving us some information about you and your API lets us know how we can best work together. Click the button below to get started!                        
                        </p>
                        <a className='usa-button' href='https://servicedesk.cdc.gov/esc?id=sc_cat_item&table=sc_cat_item&sys_id=6c00be721be286d06aa6ece2604bcb33' target="_blank" rel="noopener noreferrer">
                            Get Started
                        </a>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2content"
                        id="panel2-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">2. Prepare your API for publication</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            We’re here to make sure nothing gets overlooked as we publish and test your API before and after it reaches production. We’ll be with you every step of the way as we both complete tasks to expose your API on Digital Gateway.
                        </p>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3-content"
                            id="panel3-header"
                            className="accordion-summary"
                        >
                            <Typography component="span" className="patua-one-regular fs-17">3. Onboard consumers</Typography>
                        </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            Onboarding existing and new consumers is easy when you have our support. Please do not hesitate to reach out to our team for any questions or concerns. We're <a href='/support-ticket/submit-support-ticket' target="_blank" rel="noopener noreferrer">here</a> if you need us!
                        </p> 
                    </AccordionDetails>
                    </Accordion>
                </div>
                </div>
            </section>
        </BecomeApiProviderTemplate>
    )
}

export default PublishingApis;